module.exports = __webpack_public_path__ + "static/recarga-f1ad9ac633ab90cea2a0ed6131a27cfd.png";